import React from 'react';
import { observer } from 'mobx-react';

const EmbedLayout = observer((props) => {
    return (
        <>
                {props.children}     
        </>   
    );
});

export default EmbedLayout;